var React = require('react');

function Arrowhead (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m5 0 5 7h-10z","fill":"#2a2d58","transform":"matrix(0 1 -1 0 7 0)"}));
}

Arrowhead.defaultProps = {"height":"10","viewBox":"0 0 7 10","width":"7"};

module.exports = Arrowhead;

Arrowhead.default = Arrowhead;
